/* eslint-disable  @typescript-eslint/no-explicit-any */ // AJB: remove
"use client";

import AdDetailModel from "@/models/AdDetailModel";
import { Box, Theme, Typography } from "@mui/material";
import AdSummary from "./AdSummary";
import AdPedigreeTree from "./AdPedigreeTree";
import AdMeta from "./AdMeta";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { AdPendingAlert } from "./AdPendingAlert";
import { AdInsuranceEstimate } from "./AdInsuranceEstimate";
import { AD_DETAILS_2_COLUMN_MAX_WIDTH } from "@/app/layout/LayoutConstants";
import { TrackedLink } from "@/components/shared/TrackedLink";
import { CreateAnalyticEvent } from "@/actions/details/CreateAnalyticEvent";
import { AdNutritionWidget } from "./AdNutritionWidget";

export const AD_DESCRIPTION_STYLING = (theme: Theme) => ({
  "& p": {
    margin: theme.spacing(0.25, 0),
    minHeight: "1.5em",
  },
  "& a": {
    textDecoration: "underline",
  },
  "& ul, & ol": {
    paddingLeft: theme.spacing(4),
    margin: theme.spacing(1, 0),
  },
});

export default function AdBody({ ad }: { ad: AdDetailModel }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          alignItems: "stretch",
        }}
      >
        <AdPendingAlert ad={ad} />
        <Box
          sx={(theme) => ({
            display: "flex",
            gap: 4,
            width: "100%",
            alignItems: "start",
            [theme.breakpoints.down("sm")]: {
              flexDirection: "column",
              alignItems: "stretch",
              gap: 2,
            },
          })}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              width: "100%",
            }}
          >
            <Typography
              variant="h4"
              component="h1"
              sx={(theme) => ({
                fontWeight: "bold",
                [theme.breakpoints.down("md")]: {
                  fontSize: "1.5rem",
                },
              })}
            >
              {ad.title}
            </Typography>
            <TrackedLink
              href={`https://www.google.com/maps/search/?api=1&query=${ad.location.label}`}
            >
              <Typography
                sx={{
                  textDecoration: "underline",
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                }}
              >
                {ad.location.label}
                <OpenInNewIcon sx={{ height: "14px" }} />
              </Typography>
            </TrackedLink>
            <AdMeta ad={ad} />
            <Box sx={{ marginTop: 3 }}>
              <AdSummary ad={ad} />
            </Box>
          </Box>
          {ad.insurance && (
            <Box
              sx={(theme) => ({
                margin: theme.spacing(1, -2),
                [theme.breakpoints.down(AD_DETAILS_2_COLUMN_MAX_WIDTH)]: {
                  margin: theme.spacing(1, 0),
                },
              })}
            >
              <AdInsuranceEstimate insurance={ad.insurance} />{" "}
            </Box>
          )}
        </Box>
      </Box>
      <Box
        sx={(theme) => ({
          [theme.breakpoints.down("sm")]: {
            display: "flex",
            flexDirection: "column",
            gap: 2,
          },
        })}
      >
        <Box
          sx={(theme) => ({
            float: "right",
            margin: theme.spacing(0, -2, 4, 4),
            [theme.breakpoints.down(AD_DETAILS_2_COLUMN_MAX_WIDTH)]: {
              marginRight: 0,
            },
            [theme.breakpoints.down("sm")]: {
              float: "none",
              order: 1,
              margin: 0,
            },
          })}
        >
          <AdNutritionWidget />
        </Box>
        <Typography
          component="div"
          sx={AD_DESCRIPTION_STYLING}
          onClick={(e: any) => {
            if (e.target.href) {
              CreateAnalyticEvent({
                event: {
                  adIds: [ad.id],
                  eventType: "CLICK#LINK#OUT",
                  metadata: {
                    href: e.target.href,
                    text: e.target.textContent || "NONE",
                  },
                },
              });
            }
          }}
          dangerouslySetInnerHTML={{
            __html: ad.descriptionHtml,
          }}
        />
      </Box>
      <Typography>{ad.priceGst}</Typography>
      <AdPedigreeTree ad={ad} />
    </Box>
  );
}
